import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import { setCurrentNavPage } from "actions";
import PageHeader from "../../components/common/PageHeader/PageHeader";
import _ from "i18n";
import PeriodFilter from "../../components/Filters/EventStats/PeriodFilter";
import BelgiumCityMap from '../../components/Admin/EventStats/EventRegistrantLinechart/BelgiumMap';
import { getAccumulateStats, getCAByFormat, getCotisationMonths, getMembershipAssociative, getNbrCotisantByFormat, getNbrCotisants, getTypeFormats } from '../../actions/thunks/statistics';
import { Checkbox, Col, DatePicker, Icon, Progress, Row } from 'antd';
import ContributionChart from '../../components/Admin/EventStats/EventRegistrantLinechart/ContributionChart';
import { CommonLoader } from '../../components/common/CommonLoader';
import CotisantFilters from '../../components/Admin/EventStats/EventRegistrantLinechart/CotisantFilters';
import CotisantStats from '../../components/Admin/EventStats/EventRegistrantLinechart/CotisantStats';
import { formatCotisantData, newSeasonFilterStyle } from '../../services/utils';
import CotisantStatsChartLine from '../../components/Admin/EventStats/EventRegistrantLinechart/CotisantStatsChartLine';
import CotisantStatsCompare from '../../components/Admin/EventStats/EventRegistrantLinechart/CotisantStatsCompare';
import moment from 'moment';
import CotisantStatsChartLineCompare from '../../components/Admin/EventStats/EventRegistrantLinechart/CotisantStatsChartLineCompare';
import CotisationFilterTypeCotisation from '../../components/Admin/EventStats/EventRegistrantLinechart/CotisationFilterTypeCotisation';
import ReactSelect, { components } from "react-select";
import t from "i18n";
import { deleteCacheForCotisationStats, getCacheOldestEntryPeriodForCotisationStats } from '../../actions/thunks/eventStats';
import MonthFilterContribution from '../../components/Filters/EventStats/CompareStats/MonthFilterContribution';
import PeriodFilterCotisation from '../../components/Filters/EventStats/PeriodFilterCotisation';


const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <img src={"/img/icons/Polygon.svg"} className={'mr-1'} />
    </components.DropdownIndicator>
  );
};
class ContributionStatisticsPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      period: new Date().getFullYear(),
      cityPercentageData: {},
      topFiveCityPercentageData: [],
      typeCotisants: {},
      nbrInscriptionFetch: false,
      typeCotisantsFetch: false,
      activeTab: "cotisation",
      activeTabTypeCotisation: "cotisation",
      selectedFrequency: "MONTHLY",
      nbrCotisantByFormat: {},
      nbrCotisantByFormatPrevYear: {},
      nbrCotisantByFormatFetch: false,
      caCotisantByFormat: {},
      caCotisantByFormatPrevYear: {},
      caCotisantByFormatFetch: false,
      nbrCotisantByFormatCompare: {},
      nbrCotisantByFormatCompareFetch: false,
      caCotisantByFormatCompare: {},
      caCotisantByFormatCompareFetch: false,
      showCompareStats: false,
      monthsForDaily: [],
      selectedMonth: "",
      associativeMembership: 0,
      fetchingMembershipAssociative: false,
      membershipAssociativeComapre: 0,
      membershipAssociativeComapreFetch: false,
      showAccumulateStats: false,
      nbrCotisantByFormatAccumulate: {},
      nbrCotisantByFormatAccumulateFetch: false,
      caCotisantByFormatAccumulate: {},
      caCotisantByFormatAccumulateFetch: false,
      nbrCotisantByFormatAccumulateCompare: {},
      nbrCotisantByFormatAccumulateCompareFetch: false,
      caCotisantByFormatAccumulateCompare: {},
      caCotisantByFormatAccumulateCompareFetch: false,
      refreshing: false,
      cacheOldestEntryPeriod: 0,
      fetchingCacheOldestEntryPeriod: true,
      visibleKeys: ['Statutaire', 'Fiduciaire'],
      showCompareAppTypeStats: false,
      showCompareAppTypeStatsArray: [],
      lineNameForStats: '',
      compareAll: false,
      startMonth: '2024-10',
      endMonth: '2025-12',
    };
  }

  componentDidMount() {
    const { eventStatsFilter } = this.props;
    const { selectedFrequency, period } = this.state;

    this.props.setCurrentNavPage("CONTRIBUTION");
    this.setState({ nbrInscriptionFetch: true, typeCotisantsFetch: true, nbrCotisantByFormatFetch: true, caCotisantByFormatFetch: true, fetchingMembershipAssociative: true });

    this.props.getCacheOldestEntryPeriodForCotisationStats().then((res) => {
      this.setState({ cacheOldestEntryPeriod: res.data.data.cacheOldestEntryPeriod, fetchingCacheOldestEntryPeriod: false })
    });

    this.props.getNbrCotisants([period]).then((res) => {
      const cityPercentageData = Object.values(res.value.data.data).reduce((acc, item) => {
        const regionKey = item.region === "Bruxelles-Capitale - Brussel-Hoofdstad"
          ? "Bruxelles"
          : item.region;

        acc[regionKey] = [item.nbrInscription, item.ca];
        return acc;
      }, {});

      const sortedData = Object.values(res.value.data.data).sort((a, b) => b.ca - a.ca);
      const topFiveCityPercentageData = sortedData.slice(0, 5);

      this.setState({ cityPercentageData, topFiveCityPercentageData, nbrInscriptionFetch: false });
    });

    this.props.getTypeFormats([period]).then((res) => {
      this.setState({ typeCotisants: res.value.data.data, typeCotisantsFetch: false });
    });

    this.props.getNbrCotisantByFormat([period], selectedFrequency).then((res) => {
      this.setState({ nbrCotisantByFormat: res.value.data.data, nbrCotisantByFormatFetch: false });
    });

    this.props.getCAByFormat([period], selectedFrequency).then((res) => {
      this.setState({ caCotisantByFormat: res.value.data.data, caCotisantByFormatFetch: false });
    });

    this.props.getCotisationMonths([period]).then((res) => {
      // get the current year and month like 2023-10
      const currentYear = moment().format('YYYY');
      const currentMonth = moment().format('MM');
      const currentYearMonth = `${currentYear}-${currentMonth}`;
      this.setState({ monthsForDaily: res.value.data.data, selectedMonth: currentYearMonth });
    });

    this.props.getMembershipAssociative([period], this.state.selectedFrequency).then((res) => {
      this.setState({ associativeMembership: res.value.data.data.sum, fetchingMembershipAssociative: false });
    });

    const showCompareAppTypeStatsArray = [];
    showCompareAppTypeStatsArray['Statutaire'] = false;
    showCompareAppTypeStatsArray['Fiduciaire'] = false;
    this.setState({ showCompareAppTypeStatsArray: showCompareAppTypeStatsArray })

    // if(this.props.eventStatsFilter.year.length == 1 && this.state.selectedFrequency == 'MONTHLY') {
    //   this.props.getNbrCotisantByFormat([this.props.eventStatsFilter.year[0] - 1], this.props.eventStatsFilter.year.length > 1 ? "YEARLY" : this.state.selectedFrequency).then((res) => {
    //     this.setState({nbrCotisantByFormatCompare: res.value.data.data, nbrCotisantByFormatCompareFetch: false});
    //   });
    // }
  }

  componentDidUpdate(prevProps, prevState) {
    const { eventStatsFilter } = this.props;
    const {
      selectedFrequency,
      selectedMonth,
      showCompareStats,
      period
    } = this.state;
    const yearsFrom2024 = Array.from({ length: new Date().getFullYear() - 2024 + 1 }, (v, k) => k + 2024);

    if (prevState.period != period) {
      this.setState({ nbrInscriptionFetch: true, typeCotisantsFetch: true, nbrCotisantByFormatFetch: true, fetchingMembershipAssociative: true, showCompareAppTypeStats: false, visibleKeys: ['Statutaire', 'Fiduciaire'], showAccumulateStats: false, compareAll: false });
      this.setState({
        startMonth: `${period - 1}-10`,
        endMonth: `${period}-12`,
      })
      // if (eventStatsFilter.year.length == 0)
      //   this.setState({ selectedFrequency: 'YEARLY' });
      // else if (eventStatsFilter.year.length == 1)
      //   this.setState({ selectedFrequency: 'MONTHLY' });
      // else if (eventStatsFilter.year.length > 1)
      //   this.setState({ selectedFrequency: 'YEARLY' });

      this.props.getNbrCotisants([period]).then((res) => {
        const cityPercentageData = Object.values(res.value.data.data).reduce((acc, item) => {
          const regionKey = item.region === "Bruxelles-Capitale - Brussel-Hoofdstad"
            ? "Bruxelles"
            : item.region;

          acc[regionKey] = [item.nbrInscription, item.ca];
          return acc;
        }, {});

        const sortedData = Object.values(res.value.data.data).sort((a, b) => b.ca - a.ca);
        const topFiveCityPercentageData = sortedData.slice(0, 5);

        this.setState({ cityPercentageData, topFiveCityPercentageData, nbrInscriptionFetch: false });
      });

      this.props.getTypeFormats([period]).then((res) => {
        this.setState({ typeCotisants: res.value.data.data, typeCotisantsFetch: false });
      });

      this.props.getNbrCotisantByFormat([period], "MONTHLY").then((res) => {
        this.setState({ nbrCotisantByFormat: res.value.data.data, nbrCotisantByFormatFetch: false });
      });

      this.props.getCAByFormat([period], "MONTHLY").then((res) => {
        this.setState({ caCotisantByFormat: res.value.data.data, caCotisantByFormatFetch: false });
      });

      this.props.getMembershipAssociative([period], "MONTHLY").then((res) => {
        this.setState({ associativeMembership: res.value.data.data.sum, fetchingMembershipAssociative: false });
      });

      // if (eventStatsFilter.year.length == 1) {
        this.props.getCotisationMonths([period]).then((res) => {
          // get the current year and month like 2023-10
          const currentYear = moment().format('YYYY');
          const currentMonth = moment().format('MM');
          const currentYearMonth = `${currentYear}-${currentMonth}`;

          this.setState({ monthsForDaily: res.value.data.data, selectedMonth: currentYearMonth });
        });
      // }
    }

    if (prevState.selectedFrequency != selectedFrequency) {
      this.setState({ nbrCotisantByFormatFetch: true, caCotisantByFormatFetch: true, typeCotisantsFetch: true, showCompareAppTypeStats: false, visibleKeys: ['Statutaire', 'Fiduciaire'], showAccumulateStats: false, compareAll: false });

      this.props.getTypeFormats([period]).then((res) => {
        this.setState({ typeCotisants: res.value.data.data, typeCotisantsFetch: false });
      });

      if (selectedFrequency !== "DAILY") {
        this.props.getNbrCotisantByFormat([period], this.state.selectedFrequency).then((res) => {
          this.setState({ nbrCotisantByFormat: res.value.data.data, nbrCotisantByFormatFetch: false });
        });

        this.props.getCAByFormat([period], this.state.selectedFrequency).then((res) => {
          this.setState({ caCotisantByFormat: res.value.data.data, caCotisantByFormatFetch: false });
        });

        this.props.getMembershipAssociative([period], this.state.selectedFrequency).then((res) => {
          this.setState({ associativeMembership: res.value.data.data.sum, fetchingMembershipAssociative: false });
        });
      }

      if (selectedFrequency === "DAILY") {
        this.setState({ nbrCotisantByFormatAccumulateFetch: true, caCotisantByFormatAccumulateFetch: true });
        const [year, month] = selectedMonth.split("-");

        this.props.getCAByFormat([period], "DAILY", selectedMonth).then((res) => {
          this.setState({ caCotisantByFormat: res.value.data.data });
          this.props.getCAByFormat([period - 1], "DAILY", `${year - 1}-${month}`).then((res) => {
            this.setState({ caCotisantByFormatPrevYear: res.value.data.data, caCotisantByFormatFetch: false });
          });
        });


        this.props.getNbrCotisantByFormat([period], "DAILY", selectedMonth).then((res) => {
          this.setState({ nbrCotisantByFormat: res.value.data.data });
          this.props.getNbrCotisantByFormat([period - 1], "DAILY", `${year - 1}-${month}`).then((res) => {
            this.setState({ nbrCotisantByFormatPrevYear: res.value.data.data, nbrCotisantByFormatFetch: false });

          });
        });

        this.props.getMembershipAssociative([period], "DAILY", selectedMonth).then((res) => {
          this.setState({ associativeMembership: res.value.data.data.sum, fetchingMembershipAssociative: false });
        });

        this.props.getAccumulateStats([period], selectedFrequency, selectedMonth, 'NBR_COTISATIONS').then((res) => {
          this.setState({ nbrCotisantByFormatAccumulate: res.value.data.data, nbrCotisantByFormatAccumulateFetch: false });
        });

        this.props.getAccumulateStats([period], selectedFrequency, selectedMonth, 'CA').then((res) => {
          this.setState({ caCotisantByFormatAccumulate: res.value.data.data, caCotisantByFormatAccumulateFetch: false });
        });

        this.props.getAccumulateStats([period - 1], selectedFrequency, `${year - 1}-${month}`, 'NBR_COTISATIONS').then((res) => {
          this.setState({ nbrCotisantByFormatAccumulateCompare: res.value.data.data, nbrCotisantByFormatAccumulateCompareFetch: false });
        });

        this.props.getAccumulateStats([period - 1], selectedFrequency, `${year - 1}-${month}`, 'CA').then((res) => {
          this.setState({ caCotisantByFormatAccumulateCompare: res.value.data.data, caCotisantByFormatAccumulateCompareFetch: false });
        });
      }
    }

    if (prevState.selectedMonth != selectedMonth) {
      if (selectedFrequency === "DAILY") {
        const showCompareAppTypeStatsArray = [];
        showCompareAppTypeStatsArray['Statutaire'] = false;
        showCompareAppTypeStatsArray['Fiduciaire'] = false;
        this.setState({ nbrCotisantByFormatFetch: true, caCotisantByFormatFetch: true, fetchingMembershipAssociative: true, showCompareStats: false, nbrCotisantByFormatAccumulateFetch: true, caCotisantByFormatAccumulateFetch: true, showCompareAppTypeStats: false, compareAll: false, visibleKeys: ['Statutaire', 'Fiduciaire'], showCompareAppTypeStatsArray: showCompareAppTypeStatsArray });
        const [year, month] = selectedMonth.split("-");

        this.props.getCAByFormat([period], "DAILY", selectedMonth).then((res) => {
          this.setState({ caCotisantByFormat: res.value.data.data });
          this.props.getCAByFormat([period - 1], "DAILY", `${year - 1}-${month}`).then((res) => {
            this.setState({ caCotisantByFormatPrevYear: res.value.data.data, caCotisantByFormatFetch: false });
          });
        });

        this.props.getNbrCotisantByFormat([period], "DAILY", selectedMonth).then((res) => {
          this.setState({ nbrCotisantByFormat: res.value.data.data });
          this.props.getNbrCotisantByFormat([period - 1], "DAILY", `${year - 1}-${month}`).then((res) => {
            this.setState({ nbrCotisantByFormatPrevYear: res.value.data.data, nbrCotisantByFormatFetch: false });

          });
        });

        this.props.getMembershipAssociative([period], "DAILY", selectedMonth).then((res) => {
          this.setState({ associativeMembership: res.value.data.data.sum, fetchingMembershipAssociative: false });
        });

        this.props.getAccumulateStats([period], selectedFrequency, selectedMonth, 'NBR_COTISATIONS').then((res) => {
          this.setState({ nbrCotisantByFormatAccumulate: res.value.data.data, nbrCotisantByFormatAccumulateFetch: false });
        });

        this.props.getAccumulateStats([period], selectedFrequency, selectedMonth, 'CA').then((res) => {
          this.setState({ caCotisantByFormatAccumulate: res.value.data.data, caCotisantByFormatAccumulateFetch: false });
        });

        this.props.getAccumulateStats([period - 1], selectedFrequency, `${year - 1}-${month}`, 'NBR_COTISATIONS').then((res) => {
          this.setState({ nbrCotisantByFormatAccumulateCompare: res.value.data.data, nbrCotisantByFormatAccumulateCompareFetch: false });
        });

        this.props.getAccumulateStats([period - 1], selectedFrequency, `${year - 1}-${month}`, 'CA').then((res) => {
          this.setState({ caCotisantByFormatAccumulateCompare: res.value.data.data, caCotisantByFormatAccumulateCompareFetch: false });
        });
      }
    }

    if (prevState.showCompareStats != showCompareStats) {
      this.setState({ nbrCotisantByFormatCompareFetch: true, caCotisantByFormatCompareFetch: true, membershipAssociativeComapreFetch: true, visibleKeys: ['Statutaire', 'Fiduciaire'] });
      if (selectedFrequency == 'MONTHLY' && showCompareStats == true) {
        this.props.getNbrCotisantByFormat([period - 1], "MONTHLY").then((res) => {
          this.setState({ nbrCotisantByFormatCompare: res.value.data.data, nbrCotisantByFormatCompareFetch: false });
        });

        this.props.getCAByFormat([period - 1], "MONTHLY").then((res) => {
          this.setState({ caCotisantByFormatCompare: res.value.data.data, caCotisantByFormatCompareFetch: false });
        });

        this.props.getMembershipAssociative([period - 1], "MONTHLY").then((res) => {
          this.setState({ membershipAssociativeComapre: res.value.data.data.sum, membershipAssociativeComapreFetch: false });
        });
      } else if (selectedFrequency == 'DAILY' && showCompareStats == true) {
        const [year, month] = selectedMonth.split("-");
        this.props.getNbrCotisantByFormat([period - 1], "DAILY", `${year - 1}-${month}`).then((res) => {
          this.setState({ nbrCotisantByFormatCompare: res.value.data.data, nbrCotisantByFormatCompareFetch: false });
        });

        this.props.getCAByFormat([period - 1], "DAILY", `${year - 1}-${month}`).then((res) => {
          this.setState({ caCotisantByFormatCompare: res.value.data.data, caCotisantByFormatCompareFetch: false });
        });

        this.props.getMembershipAssociative([period - 1], "DAILY", `${year - 1}-${month}`).then((res) => {
          this.setState({ membershipAssociativeComapre: res.value.data.data.sum, membershipAssociativeComapreFetch: false });
        });

        this.props.getAccumulateStats([period - 1], selectedFrequency, `${year - 1}-${month}`, 'NBR_COTISATIONS').then((res) => {
          this.setState({ nbrCotisantByFormatAccumulateCompare: res.value.data.data, nbrCotisantByFormatAccumulateCompareFetch: false });
        });

        this.props.getAccumulateStats([period - 1], selectedFrequency, `${year - 1}-${month}`, 'CA').then((res) => {
          this.setState({ caCotisantByFormatAccumulateCompare: res.value.data.data, caCotisantByFormatAccumulateCompareFetch: false });
        });
      }
    }
  }

  handleChangePeriod = (period) => {
    this.setState({ period });
  }

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  };

  handleTabTypeCotisationChange = (tab) => {
    this.setState({ activeTabTypeCotisation: tab });
  };

  handleFrequencyChange = (period) => {
    this.setState({ selectedFrequency: period, showCompareStats: false });
  };

  handleShowCompareStats = (show) => {
    this.setState({ showCompareStats: show });
  }

  handleChange = (event) => {
    this.setState({ selectedMonth: event.target.value });
  };

  handleSelectChange = (value) => {
    this.setState({ selectedMonth: value.value });
  };

  handleChangeCheckbox = (event) => {
    this.setState({ showAccumulateStats: event.target.checked });
  };

  refreshData = () => {
    const { eventStatsFilter } = this.props;
    const { period } = this.state;
    this.setState({ refreshing: true, nbrInscriptionFetch: true, typeCotisantsFetch: true, nbrCotisantByFormatFetch: true, fetchingMembershipAssociative: true });

    this.props.getNbrCotisants([period]).then((res) => {
      const cityPercentageData = res.value.data.data.reduce((acc, item) => {
        const regionKey = item.region === "Bruxelles-Capitale - Brussel-Hoofdstad" ? "Bruxelles" : item.region;
        acc[regionKey] = [item.nbrInscription, item.ca];
        return acc;
      }, {});

      const topFiveCityPercentageData = res.value.data.data.slice(0, 5);

      this.setState({ cityPercentageData, topFiveCityPercentageData });
    });

    this.props.getTypeFormats([period]).then((res) => {
      this.setState({ typeCotisants: res.value.data.data });
    });

    this.props.getNbrCotisantByFormat([period], this.state.selectedFrequency, this.state.selectedMonth).then((res) => {
      this.setState({ nbrCotisantByFormat: res.value.data.data });
    });

    this.props.getCAByFormat([period], this.state.selectedFrequency, this.state.selectedMonth).then((res) => {
      this.setState({ caCotisantByFormat: res.value.data.data });
    });

    this.props.getMembershipAssociative([period], this.state.selectedFrequency, this.state.selectedMonth).then((res) => {
      this.setState({ associativeMembership: res.value.data.data.sum });
    });

    this.props.getAccumulateStats([period], this.state.selectedFrequency, this.state.selectedMonth, 'NBR_COTISATIONS').then((res) => {
      this.setState({ nbrCotisantByFormatAccumulate: res.value.data.data, nbrCotisantByFormatAccumulateFetch: false });
    });

    this.props.getAccumulateStats([period], this.state.selectedFrequency, this.state.selectedMonth, 'CA').then((res) => {
      this.setState({ caCotisantByFormatAccumulate: res.value.data.data, caCotisantByFormatAccumulateFetch: false });
    });

    this.props.deleteCacheForCotisationStats().then((res) => {
      this.setState({ refreshing: false, cacheOldestEntryPeriod: 0, nbrInscriptionFetch: false, typeCotisantsFetch: false, nbrCotisantByFormatFetch: false, fetchingMembershipAssociative: false });
    }).catch((err) => {
      this.setState({ refreshing: false, nbrInscriptionFetch: false, typeCotisantsFetch: false, nbrCotisantByFormatFetch: false, fetchingMembershipAssociative: false });
    });
  }

  secondsToHm = (d) => {
    if (d < 60)
      return _('NOW');

    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);

    var hDisplay = h > 0 ? h + "h" : "";
    var mDisplay = m >= 10 ? m + "min" : "0" + m + "min";

    return hDisplay + mDisplay;
  }

  handleToggleKey = (key) => {
    this.setState(prev => ({
      visibleKeys: prev.visibleKeys.includes(key)
        ? prev.visibleKeys.filter(k => k !== key)
        : [...prev.visibleKeys, key]
    }));
  };

  showCompareStatsForAppType = (lineName) => {
    if (lineName === this.state.lineNameForStats) {
      const showCompareAppTypeStatsArray = Object.keys(this.state.showCompareAppTypeStatsArray).reduce(
        (acc, key) => {
          acc[key] = false;
          return acc;
        },
        {}
      );
      this.setState({ showCompareAppTypeStats: false, lineNameForStats: '', showCompareAppTypeStatsArray: showCompareAppTypeStatsArray, visibleKeys: ['Statutaire', 'Fiduciaire'] });
      return;
    };

    const showCompareAppTypeStatsArray = Object.keys(this.state.showCompareAppTypeStatsArray).reduce(
      (acc, key) => {
        acc[key] = key === lineName;
        return acc;
      },
      {}
    );
    this.setState({ showCompareAppTypeStats: true, lineNameForStats: lineName, showCompareAppTypeStatsArray: showCompareAppTypeStatsArray, compareAll: false, visibleKeys: [lineName] });
  }

  showCompareStatsForAllAppType = (compareAll) => {
    const showCompareAppTypeStatsArray = Object.keys(this.state.showCompareAppTypeStatsArray).reduce(
      (acc, key) => {
        acc[key] = false;
        return acc;
      },
      {}
    );
    this.setState({ showCompareAppTypeStats: !compareAll, lineNameForStats: '', showCompareAppTypeStatsArray: showCompareAppTypeStatsArray, compareAll: !compareAll, visibleKeys: ['Statutaire', 'Fiduciaire'] });
  };

  filterDataByLineName = (data, lineNameForStats) => {
    return Object.fromEntries(
      Object.entries(data).map(([date, values]) => {
        if (lineNameForStats === 'Statutaire') {
          return [date, Object.fromEntries(
            Object.entries(values).filter(([key]) => ['1', '2', '3', '4'].includes(key.toString()))
          )];
        } else if (lineNameForStats === 'Fiduciaire') {
          return [date, { 5: values[5] }];
        } else {
          return [date, values]; // fallback
        }
      })
    );
  }

  handleStartMonthChange = (startMonth) => {
    this.setState(prev => {
      const newState = { startMonth };

      if (startMonth > prev.endMonth) {
        newState.endMonth = startMonth;
      }

      return newState;
    });
  };

  handleEndMonthChange = (endMonth) => {
    this.setState(prev => {
      const newState = { endMonth };

      if (endMonth < prev.startMonth) {
        newState.startMonth = endMonth;
      }

      return newState;
    });
  };


  render() {
    const {
      activeTab,
      nbrCotisantByFormat,
      nbrCotisantByFormatFetch,
      caCotisantByFormat,
      caCotisantByFormatFetch,
      nbrCotisantByFormatCompare,
      nbrCotisantByFormatCompareFetch,
      caCotisantByFormatCompare,
      caCotisantByFormatCompareFetch,
      monthsForDaily,
      typeCotisantsFetch,
      cityPercentageData,
      nbrInscriptionFetch,
      typeCotisants,
      activeTabTypeCotisation,
      selectedFrequency,
      selectedMonth,
      associativeMembership,
      fetchingMembershipAssociative,
      membershipAssociativeComapre,
      membershipAssociativeComapreFetch,
      showAccumulateStats,
      nbrCotisantByFormatAccumulate,
      nbrCotisantByFormatAccumulateFetch,
      caCotisantByFormatAccumulate,
      caCotisantByFormatAccumulateFetch,
      nbrCotisantByFormatAccumulateCompare,
      nbrCotisantByFormatAccumulateCompareFetch,
      caCotisantByFormatAccumulateCompare,
      caCotisantByFormatAccumulateCompareFetch,
      showCompareStats,
      visibleKeys,
      lineNameForStats,
      nbrCotisantByFormatPrevYear,
      caCotisantByFormatPrevYear,
      showCompareAppTypeStats,
      topFiveCityPercentageData,
      startMonth,
      endMonth,
      period,
    } = this.state;
    const { eventStatsFilter, lng } = this.props;
    const yearsOptions = [
      { value: (moment().format('YYYY')), label: (moment().format('YYYY')) },
      { value: (moment().format('YYYY') - 1), label: (moment().format('YYYY')) - 1 },
    ];
    const formattedData = formatCotisantData(nbrCotisantByFormat, `${period - 1}-10`, `${period}-12`, selectedFrequency);
    const formattedCAData = formatCotisantData(caCotisantByFormat, `${period - 1}-10`, `${period}-12`, selectedFrequency);
    const formattedDataCompareThisYear = formatCotisantData(nbrCotisantByFormat, startMonth, endMonth, selectedFrequency);
    const formattedCADataCompareThisYear = formatCotisantData(caCotisantByFormat, startMonth, endMonth, selectedFrequency);
    const formattedDataCompare = formatCotisantData(nbrCotisantByFormatCompare, `${startMonth.split("-")[0] - 1}-${startMonth.split("-")[1]}`, `${endMonth.split("-")[0] - 1}-${endMonth.split("-")[1]}`, selectedFrequency);
    const formattedCADataCompare = formatCotisantData(caCotisantByFormatCompare, `${startMonth.split("-")[0] - 1}-${startMonth.split("-")[1]}`, `${endMonth.split("-")[0] - 1}-${endMonth.split("-")[1]}`, selectedFrequency);

    let cacheOldestEntryPeriodFormatted = this.secondsToHm(this.state.cacheOldestEntryPeriod);

    const monthsForDailyForSelect = Object.values(monthsForDaily).map(date => {
      const [year, month] = date.split("-");
      return { label: `${month}/${year}`, value: date };
    });

    const monthsForDailyForSelectDefault = monthsForDailyForSelect.find(month => month.value === selectedMonth) || monthsForDailyForSelect[0];


    const nbrCotisantByFormatByLinename = lineNameForStats ? this.filterDataByLineName(nbrCotisantByFormat, lineNameForStats) : nbrCotisantByFormat;
    const caCotisantByFormatCAByLinename = lineNameForStats ? this.filterDataByLineName(caCotisantByFormat, lineNameForStats) : caCotisantByFormat;

    const nbrCotisantByFormatByLinenamePrevYear = lineNameForStats ? this.filterDataByLineName(nbrCotisantByFormatPrevYear, lineNameForStats) : nbrCotisantByFormatPrevYear;
    const caCotisantByFormatCAByLinenamePrevYear = lineNameForStats ? this.filterDataByLineName(caCotisantByFormatPrevYear, lineNameForStats) : caCotisantByFormatPrevYear;

    const totalAccumulate = topFiveCityPercentageData.reduce(
      (acc, curr) => {
        acc.nbrInscription += curr.nbrInscription;
        acc.ca += curr.ca;
        return acc;
      },
      { nbrInscription: 0, ca: 0 }
    );
    const nbrInscrit = typeCotisants.nbrInscrit || {};
    const ca = typeCotisants.ca || {};

    const nbrInscritTotal = nbrInscrit.total ? nbrInscrit.total : 0;
    const caTotal = ca.total ? ca.total : 0;

    return (
      <div style={{ backgroundColor: '#F4F7F9' }}>
        <PageHeader header={_('STATISTIQUE COTISATIONS')} subHeader={_('EN QUELQUES CHIFFRES')} icon="STATISTICS_HEADER" periodFilter={'true'}>
          <div className={'flex items-center'}>
            <PeriodFilterCotisation period={this.state.period} onChangePeriod={this.handleChangePeriod} />
          </div>
        </PageHeader>
        <div className="contribution-stats">
          <div className="contribution-stats-container" style={{ width: '80%' }}>
            {
              typeCotisantsFetch
                ?
                <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} />
                :
                <React.Fragment>
                  <div className='flex' style={{ alignItems: 'center', marginBottom: '20px' }}>
                    <Icon type="reload" spin={this.state.refreshing} style={{ fontSize: '20px', color: '#29394D' }} onClick={() => this.refreshData()} />
                    {
                      this.state.fetchingCacheOldestEntryPeriod == false &&
                      <div className={'data-info ml-2'} style={{ marginBottom: '0' }}>
                        {_('LAST_CACHE_UPDATE') + (this.state.cacheOldestEntryPeriod < 60 ? cacheOldestEntryPeriodFormatted : (lng == 'fr' ? 'il y a ' + cacheOldestEntryPeriodFormatted : (lng == 'eng' ? cacheOldestEntryPeriodFormatted + ' ago' : cacheOldestEntryPeriodFormatted + ' geleden')))}
                      </div>
                    }
                  </div>
                  <div className='flex justify-between'>
                    <div className='flex justify-between' style={{ width: '40%', flexDirection: 'column' }}>
                      <BelgiumCityMap cityPercentageData={cityPercentageData} />
                      <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <div style={{ width: '10px', height: '10px', backgroundColor: '#2d74d0' }} />
                          <span style={{ color: '#000' }}>{' > 75'}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <div style={{ width: '10px', height: '10px', backgroundColor: '#4582e4' }} />
                          <span style={{ color: '#000' }}>{' > 50'}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <div style={{ width: '10px', height: '10px', backgroundColor: '#88b0ed' }} />
                          <span style={{ color: '#000' }}>{' > 25'}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <div style={{ width: '10px', height: '10px', backgroundColor: '#dddddd' }} />
                          <span style={{ color: '#000' }}>{' < 25'}</span>
                        </div>
                      </div>
                    </div>
                    <div className='flex' style={{ width: '60%', marginLeft: '20px', flexDirection: 'column', gap: '20px' }}>
                      <h3 className='contribution-stats-title'>Top régions</h3>
                      <div style={topFiveCityPercentageData.length > 0 ? { color: '#29394D' } : { color: '#29394D', width: '100%', height: '60%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {topFiveCityPercentageData.length > 0
                          ?
                          <div>
                            {
                              topFiveCityPercentageData.map((item, index) => (
                                <React.Fragment key={index}>
                                  <Row
                                    key={index}
                                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0px' }}
                                  >
                                    <Col span={19}>{item.region}</Col>
                                    <Col span={2} style={{ borderRight: '1px solid #E1E4E8' }}>{item.nbrInscription}</Col>
                                    <Col span={3} style={{ display: 'flex', justifyContent: 'flex-end' }}>{item.ca / 100} €</Col>
                                  </Row>
                                  <div style={{ width: '100%', height: '2px', backgroundColor: '#B2BCC6' }}>
                                    <div style={{ width: `${Math.round((item.ca / topFiveCityPercentageData[0].ca) * 100)}%`, height: '2px', backgroundColor: '#18A0FB' }} />
                                  </div>
                                </React.Fragment>
                              ))
                            }

                            <Row
                              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0px' }}
                            >
                              <Col span={19}>{"Autres"}</Col>
                              <Col span={2} style={{ borderRight: '1px solid #E1E4E8' }}>{nbrInscritTotal - totalAccumulate.nbrInscription}</Col>
                              <Col span={3} style={{ display: 'flex', justifyContent: 'flex-end' }}>{(caTotal - totalAccumulate.ca) / 100} €</Col>
                            </Row>

                          </div>
                          :
                          <div>
                            <p style={{ textAlign: 'center', color: '#999' }}>{_('Aucune donnée disponible')}</p>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </React.Fragment>
            }
          </div>
          <div className="contribution-stats-container" style={{ width: '20%' }}>
            {
              nbrInscriptionFetch || typeCotisantsFetch
                ?
                <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} />
                :
                <div className='flex' style={{ flexDirection: 'column', gap: '20px' }}>
                  <h3 className='contribution-stats-title'>{t('Type cotisations')}</h3>
                  <CotisationFilterTypeCotisation
                    activeTabTypeCotisation={activeTabTypeCotisation}
                    onTabTypeCotisationChange={this.handleTabTypeCotisationChange}
                  />
                  <ContributionChart typeCotisants={typeCotisants} activeTabTypeCotisation={activeTabTypeCotisation} associativeMembership={formattedData.categories} />
                </div>
            }
          </div>
        </div>
        <div style={{ margin: '0 80px', marginTop: '40px', border: '1px solid #F1F2F4', background: '#FFF', paddingBottom: '20px' }}>
          <div className="contribution-stats-nbr-chart">
            <CotisantStats
              totalCotisations={formattedData.totalCotisations}
              categories={formattedData.categories}
              fetchingNbrCotisantByFormat={nbrCotisantByFormatFetch}
              formattedCAData={formattedCAData}
              frequency={selectedFrequency}
              year={[period]}
              month={selectedMonth}
              associativeMembership={associativeMembership}
              fetchingMembershipAssociative={fetchingMembershipAssociative}
              visibleKeys={visibleKeys}
              onToggleKey={this.handleToggleKey}
              showCompareStatsForAppType={this.showCompareStatsForAppType}
              showCompareAppTypeStatsArray={this.state.showCompareAppTypeStatsArray}
              showCompareStatsForAllAppType={this.showCompareStatsForAllAppType}
              compareAll={this.state.compareAll}
              showCompareAppTypeStats={showCompareAppTypeStats}
              showCompareStats={showCompareStats}
            />
            <div style={{ padding: '0 30px', display: 'flex', justifyContent: 'space-between', flexDirection: 'column', gap: 20, width: '60%' }}>
              <div>
                <div style={{ display: "flex", justifyContent: selectedFrequency === "DAILY" ? "space-between" : "flex-end", alignItems: "center", width: "100%" }}>
                  {
                    selectedFrequency === "DAILY" &&
                    <div>
                      {/* <select
                        className={'event-registrant-line-chart-month-picker'}
                        value={this.state.selectedMonth}
                        onChange={this.handleChange}
                      >
                        {monthsForDailyForSelect.map((month) => (
                          <option key={month.value} value={month.value}>
                            {month.label}
                          </option>
                        ))}
                      </select> */}
                      <ReactSelect
                        onChange={this.handleSelectChange}
                        styles={newSeasonFilterStyle()}
                        defaultValue={monthsForDailyForSelectDefault}
                        options={monthsForDailyForSelect}
                        components={{ DropdownIndicator, IndicatorSeparator: () => null, Input: () => null }}
                      />
                    </div>
                  }
                  {
                    selectedFrequency === "DAILY" &&
                    <div>
                      <Checkbox checked={showAccumulateStats} onChange={this.handleChangeCheckbox}>Cumulative</Checkbox>
                    </div>
                  }
                  {
                    <div style={{ display: "flex", background: "#F0F0F0", borderRadius: 20, padding: 4 }}>
                      {["DAILY", "MONTHLY", "YEARLY"].map((period) => (
                        <button
                          key={period}
                          onClick={() => this.handleFrequencyChange(period)}
                          style={{
                            border: "none",
                            padding: "6px 12px",
                            borderRadius: 20,
                            cursor: "pointer",
                            background: selectedFrequency === period ? "#6D7F92" : "transparent",
                            color: selectedFrequency === period ? "white" : "#555",
                            fontWeight: selectedFrequency === period ? "bold" : "normal",
                            width: "120px",
                            height: "32px",
                          }}
                        >
                          {t(period)}
                        </button>
                      ))}
                    </div>
                  }
                </div>
              </div>
              <div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                  <div style={{ display: "flex", gap: 30, width: "100%" }}>
                    <span
                      style={{
                        cursor: "pointer",
                        fontWeight: activeTab === "cotisation" ? "bold" : "normal",
                        borderBottom: activeTab === "cotisation" ? "3px solid #29394D" : "3px solid #ccc",
                        color: activeTab === "cotisation" ? "#29394D" : "#555",
                        paddingBottom: 5,
                        width: '100%',
                        textAlign: "center",
                      }}
                      onClick={() => this.handleTabChange("cotisation")}
                    >
                      {t('Cotisation')}
                    </span>
                    <span
                      style={{
                        cursor: "pointer",
                        fontWeight: activeTab === "chiffreAffaire" ? "bold" : "normal",
                        borderBottom: activeTab === "chiffreAffaire" ? "3px solid #29394D" : "3px solid #ccc",
                        color: activeTab === "chiffreAffaire" ? "#29394D" : "#555",
                        paddingBottom: 5,
                        width: '100%',
                        textAlign: "center",
                      }}
                      onClick={() => this.handleTabChange("chiffreAffaire")}
                    >
                      {t('CA')}
                    </span>
                  </div>
                </div>
              </div>
              <div style={{ width: '100%' }}>
                {
                  showCompareAppTypeStats
                    ?
                    <CotisantStatsChartLineCompare
                      data1={activeTab == 'chiffreAffaire' ? (showAccumulateStats ? caCotisantByFormatAccumulate : caCotisantByFormatCAByLinename) : (showAccumulateStats ? nbrCotisantByFormatAccumulate : nbrCotisantByFormatByLinename)}
                      data2={activeTab == 'chiffreAffaire' ? (showAccumulateStats ? caCotisantByFormatAccumulateCompare : caCotisantByFormatCAByLinenamePrevYear) : (showAccumulateStats ? nbrCotisantByFormatAccumulateCompare : nbrCotisantByFormatByLinenamePrevYear)}
                      activeTab={activeTab}
                      year={[period]}
                      frequency={selectedFrequency}
                      fetchingNbrCotisantByFormat={nbrCotisantByFormatFetch}
                      nbrCotisantByFormatCompareFetch={false}
                      showAccumulateStats={showAccumulateStats}
                      visibleKeys={visibleKeys}
                    />
                    :
                    <CotisantStatsChartLine
                      data={activeTab == 'chiffreAffaire' ? (showAccumulateStats ? caCotisantByFormatAccumulate : caCotisantByFormat) : (showAccumulateStats ? nbrCotisantByFormatAccumulate : nbrCotisantByFormat)}
                      activeTab={activeTab}
                      year={[period]}
                      frequency={selectedFrequency}
                      fetching={nbrCotisantByFormatFetch || nbrCotisantByFormatAccumulateFetch}
                      selectedMonth={selectedMonth}
                      showAccumulateStats={showAccumulateStats}
                      visibleKeys={visibleKeys}
                    />
                }
              </div>
            </div>
          </div>
          {showCompareStats && period > 2024 && (selectedFrequency == 'MONTHLY' || selectedFrequency == 'DAILY') && nbrCotisantByFormatFetch == false && (
            <div style={{ marginTop: '30px', padding: '0 30px', display: 'flex', justifyContent: 'space-between', gap: 20, width: '100%' }}>
              <div style={{ width: '50%' }}>
                <CotisantStatsCompare
                  totalCotisations={formattedDataCompareThisYear.totalCotisations}
                  categories={formattedDataCompareThisYear.categories}
                  fetchingNbrCotisantByFormat={nbrCotisantByFormatFetch}
                  fetchingCACotisantByFormat={caCotisantByFormatFetch}
                  currentYear={period}
                  formattedDataCompare={formattedDataCompare}
                  nbrCotisantByFormatCompareFetch={nbrCotisantByFormatCompareFetch}
                  formattedCADataCurrentYear={formattedCADataCompareThisYear}
                  formattedCADataPrevYear={formattedCADataCompare}
                  caCotisantByFormatCompareFetch={caCotisantByFormatCompareFetch}
                  associativeMembership={associativeMembership}
                  fetchingMembershipAssociative={fetchingMembershipAssociative}
                  membershipAssociativeComapre={membershipAssociativeComapre}
                  membershipAssociativeComapreFetch={membershipAssociativeComapreFetch}
                  frequency={selectedFrequency}
                  month={selectedMonth}
                  visibleKeys={visibleKeys}
                  onToggleKey={this.handleToggleKey}
                />
              </div>
              <div style={{ width: '50%', padding: '0 30px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div style={{ display: "flex", flexDirection: "column", gap: 30 }}>
                  {/* {
                    selectedFrequency === "DAILY" &&
                    <div>
                      <Checkbox checked={showAccumulateStats} onChange={this.handleChangeCheckbox}>Voir la courbe cumulative</Checkbox>
                    </div>
                  } */}
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                    <div style={{ display: "flex", gap: 30, width: "100%" }}>
                      <span
                        style={{
                          cursor: "pointer",
                          fontWeight: activeTab === "cotisation" ? "bold" : "normal",
                          borderBottom: activeTab === "cotisation" ? "3px solid #29394D" : "3px solid #ccc",
                          color: activeTab === "cotisation" ? "#29394D" : "#555",
                          paddingBottom: 5,
                          width: '100%',
                          textAlign: "center",
                        }}
                        onClick={() => this.handleTabChange("cotisation")}
                      >
                        Cotisation
                      </span>
                      <span
                        style={{
                          cursor: "pointer",
                          fontWeight: activeTab === "chiffreAffaire" ? "bold" : "normal",
                          borderBottom: activeTab === "chiffreAffaire" ? "3px solid #29394D" : "3px solid #ccc",
                          color: activeTab === "chiffreAffaire" ? "#29394D" : "#555",
                          paddingBottom: 5,
                          width: '100%',
                          textAlign: "center",
                        }}
                        onClick={() => this.handleTabChange("chiffreAffaire")}
                      >
                        Chiffre d'affaire
                      </span>
                    </div>
                  </div>
                </div>
                {
                  selectedFrequency === 'MONTHLY' &&
                  <MonthFilterContribution
                    startMonth={startMonth}
                    endMonth={endMonth}
                    year={period}
                    handleStartMonthChange={this.handleStartMonthChange}
                    handleEndMonthChange={this.handleEndMonthChange}
                  />
                }
                <CotisantStatsChartLineCompare
                  data1={activeTab == 'chiffreAffaire' ? (showAccumulateStats ? caCotisantByFormatAccumulate : caCotisantByFormat) : (showAccumulateStats ? nbrCotisantByFormatAccumulate : nbrCotisantByFormat)}
                  data2={activeTab == 'chiffreAffaire' ? (showAccumulateStats ? caCotisantByFormatAccumulateCompare : caCotisantByFormatCompare) : (showAccumulateStats ? nbrCotisantByFormatAccumulateCompare : nbrCotisantByFormatCompare)}
                  activeTab={activeTab}
                  year={[period]}
                  frequency={selectedFrequency}
                  fetchingNbrCotisantByFormat={nbrCotisantByFormatFetch}
                  nbrCotisantByFormatCompareFetch={nbrCotisantByFormatCompareFetch}
                  showAccumulateStats={showAccumulateStats}
                  visibleKeys={visibleKeys}
                  startMonth={startMonth}
                  endMonth={endMonth}
                />
              </div>
            </div>
          )}
          {
            (selectedFrequency === "MONTHLY" || selectedFrequency == 'DAILY') && period > 2024 && showCompareAppTypeStats === false &&
            <div className={"flex flex-col items-center mt-3"}>
              <span className={"event-cycle-trainings"}
                onClick={() => this.handleShowCompareStats(!showCompareStats)}>{showCompareStats ? _("REDUCE") : _("COMPARE_WITH_ANOTHER_YEAR")}</span>
              <div className={"event-cycle-chevron"}
                onClick={() => this.handleShowCompareStats(!showCompareStats)}>
                <img src="/img/icons/chevron-down.svg"
                  className={showCompareStats && "cycle-stats-chevron-rotate"} />
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  lng: state.params.lng,
  eventStatsFilter: state.filters.eventStatsFilter,
});

const mapDispatchToProps = {
  setCurrentNavPage,
  getNbrCotisants,
  getTypeFormats,
  getNbrCotisantByFormat,
  getCAByFormat,
  getCotisationMonths,
  getMembershipAssociative,
  getAccumulateStats,
  deleteCacheForCotisationStats,
  getCacheOldestEntryPeriodForCotisationStats,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContributionStatisticsPage);



// WEBPACK FOOTER //
// ./app/pages/Admin/ContributionStatisticsPage.js